import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { fetch } from 'Utils';
import { queryKey } from 'Constants';
import { DataList, DataQueryParams, Sector } from 'Types';

const config = (options = {}) => {
	return {
		...{ keepPreviousData: false },
		...options
	};
};

export const useSectors = <T = DataList<Sector>>(
	{ pageSize, pageNumber, keyword = '' }: DataQueryParams,
	options?: UseQueryOptions<T, any, DataList<Sector>>
): UseQueryResult<DataList<Sector>, unknown> => {
	return useQuery({
		queryKey: [queryKey.sectors, { pageSize, pageNumber, keyword }],
		queryFn: () => fetch.sectorList(pageSize, pageNumber, keyword),
		...config(options)
	});
};
